module.exports = __webpack_public_path__ + "img/20190820135023828.d80da1e0.jpg";